import React from "react";
import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

const AddTeachers = () => {
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userId, setUserId] = useState("");
  const [emailId, setEmailId] = useState("");
  const [teachingSubject, setTeachingSubject] = useState("");

  const addTechStaff = async () => {
    await addDoc(collection(db, "techList"), {
      firstName,
      middleName,
      lastName,
      userId,
      emailId,
      teachingSubject,
    });
  };

  return (
    <div className="container">
      <div className="p-10 ">
        <div className="py-4  mb-2 ">
          <span className="text-4xl text-black font-bold">Add Teachers</span>
        </div>
        {/* <div className="py-4 px-8">
          <div className="grid grid-cols-3 gap-4">
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                First Name
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your First Name "
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
              />
            </div>
            <div>
              <div className="mb-4">
                <label className="block text-grey-darker text-sm font-bold mb-2">
                  Middle Name
                </label>
                <input
                  className=" border rounded w-full py-2 px-3 text-grey-darker"
                  type="text"
                  placeholder="Enter Your Middle Name"
                  value={middleName}
                  onChange={(e) => {
                    setMiddleName(e.target.value);
                  }}
                />
              </div>
            </div>
            <div>
              <div className="mb-4">
                <label className="block text-grey-darker text-sm font-bold mb-2">
                  Last Name
                </label>
                <input
                  className=" border rounded w-full py-2 px-3 text-grey-darker"
                  type="text"
                  placeholder="Enter Your Last Name"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                User ID:
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your User ID"
                value={userId}
                onChange={(e) => {
                  setUserId(e.target.value);
                }}
              />
            </div>
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                Email ID:
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your Email ID"
                value={emailId}
                onChange={(e) => {
                  setEmailId(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-grey-darker text-sm font-bold mb-2">
              Teaching Subjects:
            </label>
            <input
              className=" border rounded w-full py-2 px-3 text-grey-darker"
              type="text"
              placeholder="Subjects"
              value={teachingSubject}
              onChange={(e) => {
                setTeachingSubject(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="mt-4 ">
          <button
            className="w-24 h-16 bg-blue-400  text-2xl text-white font-semibold"
            onClick={addTechStaff}
          >
            Submit
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default AddTeachers;
